import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/bars.svg'
import _imports_1 from '@/assets/images/mdi-pencil.svg'
import _imports_2 from '@/assets/images/mdi-cog.svg'
import _imports_3 from '@/assets/images/mdi-info.svg'
import _imports_4 from '@/assets/images/mollu_coconutcorn.png'


const _hoisted_1 = { class: "momotalk-wrapper" }
const _hoisted_2 = { class: "momotalk-container" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "title-icons-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "메뉴"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("몰?루파이어 "),
  /*#__PURE__*/_createElementVNode("small", null, "Mollufier")
], -1)
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "메인 페이지"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "설정 페이지"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "몰?루파이어 정보 페이지"
}, null, -1)
const _hoisted_12 = { class: "content-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "menu",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLeftTab && _ctx.toggleLeftTab(...args)))
          }, _hoisted_6)
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(['left-tab', { on: _ctx.isLeftTabOn }])
        }, [
          _createVNode(_component_RouterLink, {
            to: "/",
            replace: "",
            class: "tab active",
            onClick: _ctx.toggleLeftTab
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_RouterLink, {
            to: "/settings",
            replace: "",
            class: "tab",
            onClick: _ctx.toggleLeftTab
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_RouterLink, {
            to: "/about",
            replace: "",
            class: "tab",
            onClick: _ctx.toggleLeftTab
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 2),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_RouterView, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("img", {
        class: _normalizeClass(["container-background-image", { anim: _ctx.shouldEnableMolluImageAnimation }]),
        src: _imports_4,
        alt: "블루아카콘 by coconutcorn - 몰?루 이미지"
      }, null, 2)
    ])
  ]))
}